<template>
  <div
    :class="[{'tw-cursor-pointer': !props.static}, 'tw-flex tw-items-center', $attrs.class]"
    tabindex="0"
    :role="props.formType"
    :aria-checked="props.checked"
    @click="handleClick">
    <div 
      :class="[
        'tw-text-3xl tw-w-10 tw-h-10 tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-border tw-border-black tw-shadow-slate-500 tw-shadow-[0_0_1px_0_inset,0_0_1px_0]', 
        {'tw-rounded-full': props.formType == 'radio'}, 
        {'tw-bg-orange-medium': (props.formType == 'radio' && props.checked) },
        {'tw-rounded-xl': props.formType != 'radio' },
        {'tw-border-none tw-shadow-none tw-text-xl': props.static}
      ]">
      <span v-if="props.checked && props.formType == 'checkbox'" 
        class="fa fa-check tw-text-orange-medium" />
      <span v-if="!props.checked && props.formType == 'checkbox' && props.static" 
        class="fa fa-ellipsis-h tw-text-slate-500" />
    </div>
    <div
      :id="`label-${props.id}`"
      :class="['tw-text-xl tw-text-black tw-font-bold tw-px-4 tw-mt-0.5',
      {'tw-pl-0': props.static},
      {'tw-text-slate-500': props.static && !props.checked}
      ]">
      {{ props.label }}
    </div>
  </div>
</template>

<script setup lang="ts"> 
const emit = defineEmits(['onChange'])
 
const props = defineProps({
  value: {
    type: String,
    default: "",
  },
  label: {
    type: String,
    default: "",
  },
  cssClass: {
    type: String,
    default: "",
  },
  checked: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  formType: {
    type: String,
    default: 'checkbox'
  },
  static: {
    type: Boolean,
    default: false
  }
});
 
// const iconClass = computed(() => {
//   const { checked } = props;
//   return {
//     "tw-font-4xl check-box__icon": true,
//     "tw-font-4xl check-box__icon--checked": checked,
//   };
// });
 
const handleClick = () => {
  emit("onChange", props.id);
};
</script>